import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const PuList = () => {
  const [displayPuList, setDisplayPuList] = useState([])
  const [viewMore, setViewMore] = useState(true)


  const printRef = useRef(null)


  const print = useReactToPrint({
    content: () => printRef.current,
  });


  useEffect(() => {
    api
      .get("/companydetails/pu-given-form/")
      .then((response) => {
        console.log("pulist", response.data);
        setDisplayPuList(response.data)
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, []);


  const handleSearch = (e) => {

    api.get(`companydetails/pu-given-form/?search=${e.target.value}`)
      .then(response => {
        setDisplayPuList(response.data)
      })
      .catch(error => {
        console.log(error)
      })

  }



  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        PU Given  List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <div className="flex justify-between">
                  <input
                    placeholder="Search by Company"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search by Staff"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search by Date"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printRef} className="border-primary-blue min-w-full border text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr className="">
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        CDC No.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Company Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Address
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Letter Given Date
                      </th>

                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">

                    {displayPuList.length < 1 && "No Data found"}
                    {
                      displayPuList.slice(0, `${viewMore ? 10 : displayPuList.length}`).map((item, i) => {
                        return (
                          <tr className="border-primary-blue border-2 bg-white">
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {i + 1}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              2078/1/1
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {item.company_name}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {item.company_address}
                            </td>
                            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                              {item.date}
                            </td>

                            <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">

                              <button
                                className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                              >
                                View

                              </button>
                              <button
                                className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                              >
                                Download
                              </button>
                              <button
                                className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                              >
                                Print
                              </button>
                            </td>
                          </tr>
                        )
                      })

                    }

                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div onClick={print} className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <button >Print List</button>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                      <button onClick={() => setViewMore(true)}>View Less</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default PuList;
